module.exports = __webpack_public_path__ + "img/shopping-basket-2-line.47f4385a.svg";